export const medicationTemplates = {
  fentanyl: {
    name: 'Fentanyl',
    defaultConcentrations: [
      { value: 10, unit: 'mcg/mL', label: '10 mcg/mL (standard)' },
      { value: 50, unit: 'mcg/mL', label: '50 mcg/mL (concentrated)' },
    ],
    defaultDoseUnit: 'mcg/hr',
    defaultRateUnit: 'mL/hr',
    weightBased: true,
    weightType: 'ABW',
    doseRange: { min: 25, max: 200, unit: 'mcg/hr' },
    weightBasedRange: { min: 0.5, max: 2, unit: 'mcg/kg/hr' },
  },
  midazolam: {
    name: 'Midazolam (Versed)',
    defaultConcentrations: [
      { value: 1, unit: 'mg/mL', label: '1 mg/mL (standard)' },
      { value: 5, unit: 'mg/mL', label: '5 mg/mL (concentrated)' },
    ],
    defaultDoseUnit: 'mg/hr',
    defaultRateUnit: 'mL/hr',
    weightBased: true,
    weightType: 'ABW',
    doseRange: { min: 1, max: 10, unit: 'mg/hr' },
    weightBasedRange: { min: 0.02, max: 0.1, unit: 'mg/kg/hr' },
  },
  propofol: {
    name: 'Propofol',
    defaultConcentrations: [
      { value: 10, unit: 'mg/mL', label: '10 mg/mL (standard)' },
    ],
    defaultDoseUnit: 'mcg/kg/min',
    defaultRateUnit: 'mL/hr',
    weightBased: true,
    weightType: 'ABW',
    doseRange: { min: 5, max: 80, unit: 'mcg/kg/min' },
    weightBasedRange: { min: 5, max: 80, unit: 'mcg/kg/min' },
  },
  ketamine: {
    name: 'Ketamine',
    defaultConcentrations: [
      { value: 10, unit: 'mg/mL', label: '10 mg/mL' },
      { value: 50, unit: 'mg/mL', label: '50 mg/mL' },
    ],
    defaultDoseUnit: 'mg/hr',
    defaultRateUnit: 'mL/hr',
    weightBased: true,
    weightType: 'ABW',
    doseRange: { min: 5, max: 40, unit: 'mg/hr' },
    weightBasedRange: { min: 0.1, max: 0.5, unit: 'mg/kg/hr' },
  },
  norepinephrine: {
    name: 'Norepinephrine (Levophed)',
    defaultConcentrations: [
      { value: 16, unit: 'mcg/mL', label: '16 mcg/mL (4mg/250mL)' },
      { value: 32, unit: 'mcg/mL', label: '32 mcg/mL (8mg/250mL)' },
    ],
    defaultDoseUnit: 'mcg/min',
    defaultRateUnit: 'mL/hr',
    weightBased: false,
    weightType: 'ABW',
    doseRange: { min: 1, max: 30, unit: 'mcg/min' },
    weightBasedRange: { min: 0.01, max: 0.5, unit: 'mcg/kg/min' },
  },
  epinephrine: {
    name: 'Epinephrine',
    defaultConcentrations: [
      { value: 16, unit: 'mcg/mL', label: '16 mcg/mL (4mg/250mL)' },
      { value: 32, unit: 'mcg/mL', label: '32 mcg/mL (8mg/250mL)' },
    ],
    defaultDoseUnit: 'mcg/min',
    defaultRateUnit: 'mL/hr',
    weightBased: false,
    weightType: 'ABW',
    doseRange: { min: 1, max: 20, unit: 'mcg/min' },
    weightBasedRange: { min: 0.01, max: 0.3, unit: 'mcg/kg/min' },
  },
  vasopressin: {
    name: 'Vasopressin',
    defaultConcentrations: [
      { value: 0.4, unit: 'units/mL', label: '0.4 units/mL (20u/50mL)' },
      { value: 1, unit: 'units/mL', label: '1 unit/mL (40u/40mL)' },
    ],
    defaultDoseUnit: 'units/hr',
    defaultRateUnit: 'mL/hr',
    weightBased: false,
    weightType: 'ABW',
    doseRange: { min: 0.01, max: 0.04, unit: 'units/min' },
    weightBasedRange: null,
  },
  dopamine: {
    name: 'Dopamine',
    defaultConcentrations: [
      { value: 1600, unit: 'mcg/mL', label: '1600 mcg/mL (400mg/250mL)' },
      { value: 3200, unit: 'mcg/mL', label: '3200 mcg/mL (800mg/250mL)' },
    ],
    defaultDoseUnit: 'mcg/kg/min',
    defaultRateUnit: 'mL/hr',
    weightBased: true,
    weightType: 'ABW',
    doseRange: { min: 2, max: 20, unit: 'mcg/kg/min' },
    weightBasedRange: { min: 2, max: 20, unit: 'mcg/kg/min' },
  },
  dobutamine: {
    name: 'Dobutamine',
    defaultConcentrations: [
      { value: 1000, unit: 'mcg/mL', label: '1000 mcg/mL (250mg/250mL)' },
      { value: 2000, unit: 'mcg/mL', label: '2000 mcg/mL (500mg/250mL)' },
    ],
    defaultDoseUnit: 'mcg/kg/min',
    defaultRateUnit: 'mL/hr',
    weightBased: true,
    weightType: 'ABW',
    doseRange: { min: 2.5, max: 20, unit: 'mcg/kg/min' },
    weightBasedRange: { min: 2.5, max: 20, unit: 'mcg/kg/min' },
  },
  heparin: {
    name: 'Heparin',
    defaultConcentrations: [
      { value: 100, unit: 'units/mL', label: '100 units/mL (25,000u/250mL)' },
    ],
    defaultDoseUnit: 'units/hr',
    defaultRateUnit: 'mL/hr',
    weightBased: true,
    weightType: 'ABW',
    doseRange: { min: 500, max: 2500, unit: 'units/hr' },
    weightBasedRange: { min: 10, max: 25, unit: 'units/kg/hr' },
  },
  nitroglycerin: {
    name: 'Nitroglycerin',
    defaultConcentrations: [
      { value: 200, unit: 'mcg/mL', label: '200 mcg/mL (50mg/250mL)' },
      { value: 400, unit: 'mcg/mL', label: '400 mcg/mL (100mg/250mL)' },
    ],
    defaultDoseUnit: 'mcg/min',
    defaultRateUnit: 'mL/hr',
    weightBased: false,
    weightType: 'ABW',
    doseRange: { min: 5, max: 200, unit: 'mcg/min' },
    weightBasedRange: null,
  },
  amiodarone: {
    name: 'Amiodarone',
    defaultConcentrations: [
      { value: 1.8, unit: 'mg/mL', label: '1.8 mg/mL (450mg/250mL)' },
    ],
    defaultDoseUnit: 'mg/min',
    defaultRateUnit: 'mL/hr',
    weightBased: false,
    weightType: 'ABW',
    doseRange: { min: 0.5, max: 1, unit: 'mg/min' },
    weightBasedRange: null,
  },
};

export function getMedicationTemplate(templateId) {
  return medicationTemplates[templateId] || null;
}

export function getMedicationList() {
  return Object.entries(medicationTemplates).map(([key, val]) => ({
    key,
    name: val.name,
  }));
}
